import "slick-carousel";

// Ensure slick library has been included
if (typeof $.fn.slick == "function") {
  const $js_slider = $(".js-slider");

  $js_slider.on("init", function (event, slick) {
    var $this = $(this);
    setTimeout(function () {
      $this.find(".slick-dots").removeAttr("role");
      $this.find(".slick-dots li").removeAttr("role");
    }, 1000);
  });

  $js_slider.slick({
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fal fa-angle-left fa-3x" aria-hidden="true"></i></button></i>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fal fa-angle-right fa-3x" aria-hidden="true"></i></button>',
    customPaging: function (slider, i) {
      let thumb = $(slider.$slides[i])
        .find(".slider-slide__background-image")
        .data("thumbnail");

      return '<a><img src="' + thumb + '" alt="" role="none"/></a>';
    },
  });

  $(".js-testimonial").slick({
    mobileFirst: true,
    adaptiveHeight: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="far fa-angle-left" aria-hidden="true"></i></button></i>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="far fa-angle-right" aria-hidden="true"></i></button>',
  });

  $(".js-ctestimonial").slick({
    mobileFirst: true,
    arrows: false,
    dots: true,
  });

  $(".js-2-by-2").slick({
    mobileFirst: true,
    adaptiveHeight: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="far fa-angle-left" aria-hidden="true"></i></button></i>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="far fa-angle-right" aria-hidden="true"></i></button>',
  });

  $(".js-carousel").slick({
    mobileFirst: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fal fa-angle-left" aria-hidden="true"></i></button></i>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fal fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  $(".js-corporate-carousel").slick({
    mobileFirst: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous slide" type="button"><i class="fal fa-2x fa-angle-left" aria-hidden="true"></i></button></i>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next slide" type="button"><i class="fal fa-2x fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  });

  $(".js-upcoming-events-slider").slick({
    mobileFirst: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fal fa-angle-left" aria-hidden="true"></i></button></i>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fal fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
  $(".js-power-testimonial").slick({
    dots: true,
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".ae-testimonials-slider").slick({
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".ae-donations-slider").slick({
    arrows: false,
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

$(window).on("closed.zf.reveal", function () {
  $(".js-testimonial").slick("setPosition", 0);
});

/*timeline*/
$(".flexible-timeline--slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: ".flexible-timeline--slider-nav",
  // appendArrows: ".slider-nav",
  // prevArrow:
  //   '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="https://360kids.local/wp-content/uploads/left.svg" /></button></i>',
  // nextArrow:
  //   '<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="https://360kids.local/wp-content/uploads/right-arrow.svg"/></button>',
});

$(".flexible-timeline--slider-nav").slick({
  slidesToShow: 12,
  slidesToScroll: 1,
  asNavFor: ".flexible-timeline--slider",
  dots: false,
  focusOnSelect: true,
  infinite: true,
  appendArrows: ".slider-nav",
  prevArrow:
    '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="https://kids360stage.wpengine.com/wp-content/uploads/left.svg" /></button></i>',
  nextArrow:
    '<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="https://kids360stage.wpengine.com/wp-content/uploads/right-arrow.svg"/></button>',
});

var workSlider = $(".flexible-image--slider");
workSlider.slick({
  arrows: false,
  dots: false,
  slidesToShow: 4,
  autoplay: true,
  variableWidth: true,
  autoplaySpeed: 0,
  speed: 9000,
  pauseOnHover: false,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
